import { Capacitor, registerPlugin } from '@capacitor/core';
import { isNativeApp } from './platform';

// Native plugin defined in android/app/.../BrowserChooserPlugin.java.
const BrowserChooser = registerPlugin('BrowserChooser');

const isHttpUrl = (url) => /^https?:$/i.test(url.protocol);

// True when the Android "Open with" chooser can be used. Older APKs that were
// built before the plugin existed still load the live site, so check that the
// native side actually has it rather than assuming.
export const canUseBrowserChooser = () =>
  isNativeApp() && Capacitor.isPluginAvailable('BrowserChooser');

// Open a link outside the app. In the Android app this shows the system
// "Open with" chooser; on the web it opens a new tab.
export const openExternal = async (href) => {
  if (canUseBrowserChooser()) {
    try {
      await BrowserChooser.open({ url: href });
      return;
    } catch (err) {
      // Fall through to the default behaviour below.
    }
  }
  window.open(href, '_blank', 'noopener,noreferrer');
};

// Native-only: intercept clicks on links that leave the site and route them
// through the chooser. Returns a cleanup function.
export const installExternalLinkHandler = () => {
  if (!canUseBrowserChooser()) return () => {};

  const onClick = (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    const anchor = event.target.closest && event.target.closest('a[href]');
    if (!anchor) return;

    let url;
    try {
      url = new URL(anchor.href, window.location.href);
    } catch (err) {
      return;
    }
    if (!isHttpUrl(url) || url.origin === window.location.origin) return;

    event.preventDefault();
    openExternal(url.href);
  };

  document.addEventListener('click', onClick);
  return () => document.removeEventListener('click', onClick);
};
